import { defineComponent, toRefs } from '@vue/composition-api';
import ConfirmModal from '@/components/Modal/__new__/ConfirmModal.vue';
import DecisionBtns from '@/views/Brand/Applications/Components/Offers/Costs/_components/DecisionBtns.vue';
import StatusBtn from '@/views/Brand/Applications/Components/Offers/Costs/_components/StatusBtn.vue';
import { GoodsOfferDecisionStatus as DecisionStatus, } from '@/api/v2/requests/goods-offers';
import { useGoodsOfferAccept } from '@/views/Brand/Applications/Offer/_components/GoodsOfferAcceptItem/composables/use-goods-offer-accept';
export default defineComponent({
    name: 'GoodsOfferAcceptItem',
    components: { ConfirmModal, DecisionBtns, StatusBtn },
    props: {
        goodsOffer: {
            type: Object,
            required: true,
        },
        level: {
            type: String,
            required: true,
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['refresh'],
    setup(props, ctx) {
        const { goodsOffer, level, isReadOnly } = toRefs(props);
        const { loading, status, user, formattedDate, canUserTakeAction, canUserRevertAction, showConfirmModal, modalContent, accept, reject, revert, runActionWithModal, onCloseModal, } = useGoodsOfferAccept(ctx, {
            goodsOffer,
            level,
            isReadOnly,
        });
        function handleAccept() {
            const levelLabel = ctx.root.$t(`goods-offer.${props.level.toLowerCase()}`);
            const confirmMessage = ctx.root.$t('goods-offer.confirm-accept', {
                level: levelLabel,
            });
            runActionWithModal(String(confirmMessage), accept);
        }
        function handleReject() {
            const levelLabel = ctx.root.$t(`goods-offer.${props.level.toLowerCase()}`);
            const confirmMessage = ctx.root.$t('goods-offer.confirm-reject', {
                level: levelLabel,
            });
            runActionWithModal(String(confirmMessage), reject);
        }
        function handleRevert() {
            const levelLabel = ctx.root.$t(`goods-offer.${props.level.toLowerCase()}`);
            const confirmMessage = ctx.root.$t('goods-offer.confirm-revert', {
                level: levelLabel,
            });
            runActionWithModal(String(confirmMessage), revert);
        }
        return {
            loading,
            status,
            user,
            formattedDate,
            canUserTakeAction,
            canUserRevertAction,
            showConfirmModal,
            modalContent,
            onCloseModal,
            handleAccept,
            handleReject,
            handleRevert,
            DecisionStatus,
        };
    },
});
